import {Component, ChangeDetectionStrategy} from '@angular/core';


@Component({
  selector: 'moti-button-extended-group',
  templateUrl: './button-extended-group.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './button-extended-group.component.scss',
})
export class ButtonExtendedGroupComponent {

}
